import { render, staticRenderFns } from "./PersistRequestSswView.vue?vue&type=template&id=2822274b&"
import script from "./PersistRequestSswView.vue?vue&type=script&lang=ts&"
export * from "./PersistRequestSswView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports